<template>
  <div class="site-title__wrapper">
    <h4 class="text-h4 site-title__site-name">
      {{ title }}
    </h4>

    <h3 class="text-h3 site-title__app-name">
      {{ currentApp?.menu_name || currentApp?.name }}
    </h3>
  </div>
</template>

<script setup lang="ts">
const { title } = useAppConfig();
const { current: currentApp } = storeToRefs(useApps());
</script>

<style scoped lang="scss">
@import "~/assets/styles/variables";

.site-title__wrapper {
  overflow: hidden;
}

.site-title__site-name,
.site-title__app-name {
  overflow: hidden;
  text-overflow: ellipsis;
}

.site-title__site-name {
  color: $navigation-site-name-color;
}

.site-title__app-name {
  color: $navigation-app-name-color;
}
</style>
